<template>
  <div class="content-panel">
    <div class="panel-title toggle" @click="showFlightDetails = !showFlightDetails">
      <h3>{{ $t('travelSummary') }}</h3>
      <div class="flight-details-toggle">
        <span v-if="showFlightDetails"><i class="fal fa-minus"></i></span>
        <span v-else><i class="fal fa-plus"></i></span> 
      </div>
    </div>
    <div class="panel-body" v-if="showFlightDetails">
      <div class="flight-listing flight-listing-summary" v-if="flightDetails && flightDetails.offer">
        <div class="flight-details">
          <div class="bound" v-for="(bound, boundIndex) in flightDetails.offer.bounds" :key="boundIndex">
            <div class="title-bar">
              <p class="route">
                <span class="type" v-if="boundIndex == (flightDetails.offer.bounds.length - 1)">{{ $t('return') }}</span>
                <span class="type" v-else>{{ $t('outbound') }}</span>
                {{ bound.segments[0].from.iataCode | toCityName }} - {{bound.segments[bound.segments.length - 1].to.iataCode | toCityName }}</p>
              <p>
                <span class="time">
                  <i class="fal fa-clock"></i> {{ bound.totalTravelTime | parseDuration }}
                </span>
              </p>
            </div>
            
            <div class="details-block" v-for="(segment, segmentIndex) in bound.segments" :key="segmentIndex">
              <div class="segment-info">
                <div class="date">
                  {{ segment.from.date | moment("ddd, MMMM Do") }}
                </div>
                <div class="route">
                  <p class="times">
                    {{ [ segment.from.time, "HH:mm" ] | moment("h:mma") }}
                    <span class="divider"> — </span>
                    {{ [ segment.to.time, "HH:mm" ] | moment("h:mma") }}

                    <span class="trip-time">{{ segment.travelTime | parseDuration }}</span>
                  </p>

                  <p class="airports">
                    <span class="airport-name">{{segment.from.iataCode | toAirportName }} ({{ segment.from.iataCode }})</span>
                    - <span class="airport-name">{{segment.to.iataCode | toAirportName }} ({{ segment.to.iataCode }})</span>
                  </p>
                </div>
                <div class="airline">
                  <img class="airline-logo" :src="'https://assets.totaltravel.io/img/airlines/' + segment.marketingCarrier.iataCode + '.png'" :alt="segment.marketingCarrier.iataCode | toAirlineName" />
                  <div>
                    <p>
                      {{segment.marketingCarrier.iataCode | toAirlineName}} ({{ segment.marketingCarrier.iataCode }})
                      <i class="fal fa-info-circle" 
                        v-if="segment.marketingCarrier.iataCode != segment.operatingCarrier.iataCode" 
                        v-tooltip="$t('operatedBy') + ' ' + segment.operatingCarrier.iataCode"></i>
                    </p>
                    <p>{{ $t('flight') }} #: {{ segment.flight }}</p>
                    <p>{{ $t('class') }}: {{ segment.cabinClass }}</p>
                  </div>
                </div>
              </div>
              <div class="segment-separator" v-if="segmentIndex < bound.segments.length - 1">
                <span class="text">
                  <span class="background time">{{$moment.duration($moment(bound.segments[segmentIndex + 1].from.date + 'T' + bound.segments[segmentIndex + 1].from.time).diff($moment(segment.to.date + 'T' + segment.to.time))) | parseDuration}} </span>
                  <span class="background">{{ $t('layoverIn') }} {{segment.to.iataCode | toAirportName}} {{ $t('airport') }} ({{segment.to.iataCode}})</span>
                </span>
              </div>

              <div class="segment-separator" v-if="segmentIndex < bound.segments.length - 1 && segment.to.iataCode !== bound.segments[segmentIndex + 1].from.iataCode">
                <span class="text">
                  <span class="background">{{ $t('changeAirports') }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FlightListingSummary',

  data () {
    return {
      showFlightDetails: false,
      moment: this.$moment
    }
  },

  props: ['flightDetails']

}
</script>